<template>
  <div
    class="modal"
    tabindex="-1"
    aria-hidden="true"
    ref="editPasswordModal"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content rounded-lg">
        <div class="modal-header justify-end pt-5 pb-0 border-0">
          <a
            data-dismiss="modal"
            href="javascript:;"
            class="font-poppins text-theme-23 font-medium hover:text-theme-35"
          >
            Cerrar
          </a>
        </div>
        <div class="px-10">
          <div class="modal-body py-0">
            <h1
              class="font-crimson_pro text-theme-9 text-3xl font-bold text-center"
            >
              Cambiar mi contraseña
            </h1>
            <div class="flex flex-col w-full">
              <div class="intro-x mt-4">
                <span class="text-xs">Contraseña actual</span>
                <div class="input-group mt-1">
                  <input
                    :type="inputOldPasswordShow ? 'text' : 'password'"
                    class="form-control p-3 text-base"
                    placeholder="Contraseña actual"
                    style="border-right-width: 0"
                    ref="old-password"
                    v-model="oldPassword"
                    @cut.prevent
                    @copy.prevent
                    @paste.prevent
                    required
                  />
                  <div
                    class="input-group-text flex cursor-pointer"
                    style="border-left-width: 0; background: transparent"
                    @click="
                      changeInputShowPassword({
                        ref: 'old-password',
                        input: 'inputOldPasswordShow'
                      })
                    "
                  >
                    <EyeIcon
                      class="w-4 h-4 my-auto"
                      v-if="!inputOldPasswordShow"
                    />
                    <EyeOffIcon class="w-4 h-4 my-auto" v-else />
                  </div>
                </div>
              </div>
              <div class="intro-x mt-8">
                <span class="text-xs">Nueva contraseña</span>
                <div class="input-group mt-1">
                  <input
                    :type="inputPasswordShow ? 'text' : 'password'"
                    class="form-control p-3 text-base"
                    placeholder="Nueva contraseña"
                    style="border-right-width: 0"
                    ref="password"
                    v-model="password"
                    @cut.prevent
                    @copy.prevent
                    @paste.prevent
                    required
                  />
                  <div
                    class="input-group-text flex cursor-pointer"
                    style="border-left-width: 0; background: transparent"
                    @click="
                      changeInputShowPassword({
                        ref: 'password',
                        input: 'inputPasswordShow'
                      })
                    "
                  >
                    <EyeIcon
                      class="w-4 h-4 my-auto"
                      v-if="!inputPasswordShow"
                    />
                    <EyeOffIcon class="w-4 h-4 my-auto" v-else />
                  </div>
                </div>
              </div>
              <div class="intro-x mt-3 text-xs flex flex-col">
                <span>
                  Debe incluir
                  <span :class="{ 'text-theme-6': !passwordHasMinLenght }">
                    mínimo 8 caracteres
                  </span>
                  y cumplir 3 de estas 4 características:
                </span>
                <span
                  class="mt-1 flex"
                  :class="{ 'opacity-30': !passwordHasUpperCase }"
                >
                  <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos una
                  mayúscula
                </span>
                <span
                  class="mt-1 flex"
                  :class="{ 'opacity-30': !passwordHasLowerCase }"
                >
                  <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />
                  Al menos una minúscula
                </span>
                <span
                  class="mt-1 flex"
                  :class="{ 'opacity-30': !passwordHasNumber }"
                >
                  <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos un
                  número
                </span>
                <span
                  class="mt-1 flex"
                  :class="{ 'opacity-30': !passwordHasSpecialCharacter }"
                >
                  <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos un
                  caracter especial (#$%&_) o puntuación (,.)
                </span>
              </div>
              <div class="intro-x mt-8">
                <span class="text-xs">Confirmar contraseña</span>
                <div class="input-group mt-1 mb-2">
                  <input
                    :type="inputConfirmPasswordShow ? 'text' : 'password'"
                    class="form-control p-3 text-base"
                    placeholder="Confirmar contraseña"
                    style="border-right-width: 0"
                    ref="confirm-password"
                    v-model="confirmPassword"
                    @cut.prevent
                    @copy.prevent
                    @paste.prevent
                    required
                  />
                  <div
                    class="input-group-text flex cursor-pointer"
                    style="border-left-width: 0; background: transparent"
                    @click="
                      changeInputShowPassword({
                        ref: 'confirm-password',
                        input: 'inputConfirmPasswordShow'
                      })
                    "
                  >
                    <EyeIcon
                      class="w-4 h-4 my-auto"
                      v-if="!inputConfirmPasswordShow"
                    />
                    <EyeOffIcon class="w-4 h-4 my-auto" v-else />
                  </div>
                </div>
                <span
                  class="text-xs ml-1 text-theme-6"
                  v-if="
                    password?.length >= 8 &&
                    confirmPassword?.length >= 8 &&
                    password !== confirmPassword
                  "
                  >Las contraseñas no coinciden</span
                >
              </div>
            </div>
          </div>
          <div class="modal-footer text-right">
            <div class="flex flex-col">
              <button
                type="button"
                :disabled="!checkValidationPassword"
                @click="$emit('editPasswordAction', { oldPassword, password })"
                class="btn btn-quotation rounded-lg px-5 w-full sm:w-9/12 text-base mx-auto"
              >
                Cambiar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-quotation-outline rounded-lg px-5 mt-5 mb-3 w-full sm:w-9/12 text-base mx-auto"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modal: undefined,
      inputPasswordShow: false,
      inputOldPasswordShow: false,
      inputConfirmPasswordShow: false,
      password: undefined,
      oldPassword: undefined,
      confirmPassword: undefined
    }
  },
  emits: ['editPasswordAction'],
  methods: {
    viewModal(view = 'show') {
      if (view === 'show') {
        this.inputPasswordShow = false
        this.inputOldPasswordShow = false
        this.inputConfirmPasswordShow = false
        this.password = undefined
        this.oldPassword = undefined
        this.confirmPassword = undefined
      }
      return cash(this.modal).modal(view)
    },
    changeInputShowPassword({ ref, input }) {
      this[input] = !this[input]
      this.$refs[ref].focus()
      setTimeout(() => {
        const length = this.$refs[ref].value.length
        this.$refs[ref].setSelectionRange(length, length)
      })
    }
  },
  mounted() {
    this.modal = this.$refs.editPasswordModal
  },
  computed: {
    passwordHasMinLenght() {
      return this.password?.length >= 8
    },
    passwordHasLowerCase() {
      return /[a-z]/.test(this.password || '')
    },
    passwordHasUpperCase() {
      return /[A-Z]/.test(this.password || '')
    },
    passwordHasNumber() {
      return /\d/.test(this.password || '')
    },
    passwordHasSpecialCharacter() {
      const specialChars = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
      return specialChars.test(this.password || '')
    },
    checkValidationPassword() {
      return (
        this.oldPassword &&
        this.oldPassword !== this.password &&
        this.password?.length >= 8 &&
        this.password === this.confirmPassword &&
        this.passwordHasLowerCase +
          this.passwordHasUpperCase +
          this.passwordHasNumber +
          this.passwordHasSpecialCharacter >=
          3
      )
    }
  }
}
</script>
